import OrdersAPI from '../../../api/orders';
import types from '../../mutation-types';

export const actions = {
  get: async ({ commit }, params) => {
    commit(types.SET_ORDER_UI_FLAG, { isFetching: true });
    try {
      const response = await OrdersAPI.get(params);
      commit(types.SET_ORDERS_LIST, response.data.payload);
      commit(types.SET_ORDER_META, response.data.meta);
      commit(types.SET_ORDER_UI_FLAG, { isFetching: false });
    } catch (error) {
      commit(types.SET_ORDER_UI_FLAG, { isFetching: false });
    }
  },

  search: async ({ commit }, params) => {
    commit(types.SET_ORDER_UI_FLAG, { isFetching: true });
    try {
      const response = await OrdersAPI.search(params);
      commit(types.SET_ORDERS_LIST, response.data.payload);
      commit(types.SET_ORDER_META, response.data.meta);
      commit(types.SET_ORDER_UI_FLAG, { isFetching: false });
    } catch (error) {
      commit(types.SET_ORDER_UI_FLAG, { isFetching: false });
    }
  },

  filter: async ({ commit }, params) => {
    commit(types.SET_ORDER_UI_FLAG, { isFetching: true });
    try {
      const { payload, ...otherParams } = params;
      const response = await OrdersAPI.filter({ payload }, otherParams);
      commit(types.SET_ORDERS_LIST, response.data.payload);
      commit(types.SET_ORDER_META, response.data.meta);
      commit(types.SET_ORDER_UI_FLAG, { isFetching: false });
    } catch (error) {
      commit(types.SET_ORDER_UI_FLAG, { isFetching: false });
    }
  },

  getByContact: async ({ commit }, contactId) => {
    commit(types.SET_ORDER_UI_FLAG, { isFetching: true });
    try {
      const response = await OrdersAPI.get({ contact_id: contactId });
      const orders = response.data.payload || response.data || [];

      commit(types.SET_ORDER_UI_FLAG, { isFetching: false });
      return orders;
    } catch (error) {
      commit(types.SET_ORDER_UI_FLAG, { isFetching: false });
      throw error;
    }
  },

  setOrderFilters({ commit }, data) {
    commit(types.SET_ORDER_FILTERS, data);
  },

  clearOrderFilters({ commit }) {
    commit(types.CLEAR_ORDER_FILTERS);
  },
};
